<template>
    <step-container>
        <step-info
            :label="$t('V3_ITEM_COLOR')"
        />

        <form-fields>
            <form-fields-main-scroll>
                <template v-if="availablePrintingColorsV3.length > 0">
                    <div class="cz3__small-header">
                        {{$t('V3_PRINT_COLORS')}}

                        <info-tip
                            :tip="$t('V3_PRINT_COLORS_TIP')"
                        />
                    </div>

                    <item-colors
                        :options="availablePrintingColorsV3"
                        method="printing"
                    />
                </template>

                <template v-if="availableEtchingColorsV3.length > 0">
                    <div class="cz3__small-header">
                        {{$t('V3_ETCH_COLORS')}}

                        <info-tip
                            :tip="$t('V3_ETCH_COLORS_TIP')"
                        />
                    </div>

                    <item-colors
                        :options="availableEtchingColorsV3"
                        method="etching"
                    />
                </template>
            </form-fields-main-scroll>

            <step-buttons>
                <secondary-button
                    class="cz3__flex-1"
                    :label="$t('V3_BACK')"
                    @click="back"
                />

                <action-button
                    class="cz3__flex-1"
                    :label="$t('V3_NEXT')"
                    :disabled="reloading"
                    @click="next"
                />
            </step-buttons>
        </form-fields>
    </step-container>
</template>

<script>
    import StepContainer from './StepContainer.vue';
    import StepInfo from './StepInfo.vue';
    import FormFields from './FormFields.vue';
    import ActionButton from './ActionButton.vue';
    import SecondaryButton from './SecondaryButton.vue';
    import ItemColors from './ItemColors.vue';
    import StepButtons from './StepButtons.vue';
    import InfoTip from './InfoTip.vue';
    import FormFieldsMainScroll from './FormFieldsMainScroll.vue';

    export default {
        components: {
            StepContainer,
            StepInfo,
            FormFields,
            SecondaryButton,
            ActionButton,
            ItemColors,
            StepButtons,
            InfoTip,
            FormFieldsMainScroll,
        },

        data() {
            return {
            };
        },

        computed: {
            availablePrintingColorsV3() {
                return this.$store.getters.availablePrintingColorsV3;
            },

            availableEtchingColorsV3() {
                return this.$store.getters.availableEtchingColorsV3;
            },

            nextStep() {
                return this.$store.getters.nextStepV3;
            },

            reloading() {
                return this.$store.state.reloadingV3;
            },
        },

        methods: {
            back() {
                this.$store.dispatch('setSelectedStepV3', 'start');
            },

            next() {
                this.$store.dispatch('setSelectedStepV3', this.nextStep);
            },
        },
    };
</script>
